import React from 'react';

const Home = () => (
  <div className="home">
    <h2 className="home-title">Welcome to our page!</h2>
    <p>
      A simple to use calculator with an appealing user interface.
      A virtual calculator built with React is another good project idea
      for you to try as a beginner.
    </p>
    <br />
    <p>
      We have seen various calculator apps on our mobile phones,
      computers and different devices as well. Here we have an input box which
      takes user input as numbers and then try to do operations like addition, subtraction,
      division and multiplication etc. Here we will learn to create a web app with all the features
      of the calculator on UI.
    </p>
  </div>
);

export default Home;
